export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';

export const REGISTER_REQUEST = 'REGISTER_REQUEST';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_ERROR = 'REGISTER_ERROR';

export const RESET_PASSWORD_EMAIL_REQUEST = 'RESET_PASSWORD_EMAIL_REQUEST';
export const RESET_PASSWORD_EMAIL_SUCCESS = 'RESET_PASSWORD_EMAIL_SUCCESS';
export const RESET_PASSWORD_EMAIL_ERROR = 'RESET_PASSWORD_EMAIL_ERROR';

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';

export const SET_UBER_TOKEN = 'SET_UBER_TOKEN';
export const SET_UBER_TOKEN_ERROR = 'SET_UBER_TOKEN_ERROR';

export const CREATE_FAST_USER_SUCCESS = 'CREATE_FAST_USER_SUCCESS';
export const CREATE_FAST_USER_REQUEST = 'CREATE_FAST_USER_REQUEST';
export const CREATE_FAST_USER_ERROR = 'CREATE_FAST_USER_ERROR';
